import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Checkbox } from "@folio/stripes/components";
import styles from "./ExportApiClientRoleCheckbox.module.css";
/**
 * The technical ExportApiClient role (DB-946) with a hint that it belongs to an API-only account: the role lets the
 * account call the title export web service and nothing else, so combining it with another role defeats its purpose.
 */
export var ExportApiClientRoleCheckbox = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, name = _a.name, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(React.Fragment, null,
        React.createElement(Checkbox, { name: name, label: formatMessage({
                id: "ui-br-users.users.organization.roles.checkbox.label.exportApiClient",
            }), checked: checked, disabled: disabled, onChange: onChange }),
        React.createElement("p", { className: styles.hint },
            React.createElement(FormattedMessage, { id: "ui-br-users.users.organization.roles.exportApiClientHint" }))));
};
